// extracted by mini-css-extract-plugin
export default {"machineEmbeddedComputerDeleteButton":"machine-embedded-computers_machineEmbeddedComputerDeleteButton__Vwe-s"};